import { formatBytes, NekoIcon, NekoInput, NekoButton, NekoTheme } from '@neko-ui';
import { SectionButtonStyle } from './components/common';
import i18n from './i18n';

export const takeNap = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const executeForAtLeast = (ms, func) => {
    return new Promise(async resolve => {
        const start = new Date();
        await func();
        const end = new Date();
        const diff = end.getTime() - start.getTime();
        const need = ms - diff;
        if (need > 0) {
            await takeNap(need);
        }
        resolve();
    });
}

export const sortIgnoreItemToEnd = (list) => {
    const ignoreList = list.filter(v => v.clean_style === 'never');
    const othersList = list.filter(v => v.clean_style !== 'never');
    return [...othersList, ...ignoreList];
}

export const formatUnixtime = (unixtime) => {
    const dateTime = new Date(unixtime * 1000);
    return dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString();
}

export const formatMBytes = (mb) => {
    if (isNaN(mb)) return '-';
    
    return formatBytes(mb * 1024 * 1024);
}

export const paging = (list, page, limit) => {
    const start = (page - 1) * limit;
    const end = page * limit;
    return list.slice(start, end);
}

export const snakeToCamel = (str) => str.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
export const camelToSnake = (str) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);